import { integrations_calendars_google_index_path, sync_integrations_path } from "@/routes";
import AppLayout from "@/components/layouts/AppLayout";
import { type ReactNode, useEffect } from "react";
import { ProviderAccount } from "@/types/serializers";
import AccountCard from "./AccountCard";
import { Box, Flex, Heading, VStack, Button, Text } from "@chakra-ui/react";
import { Head, usePage } from "@inertiajs/react";
import InertiaSharedProps from "@/types/inertia";
import { useAnalytics } from "@/hooks/useAnalytics";

interface Props {
  integrations: {
    google: {
      accounts: ProviderAccount[];
    };
  };
  should_show_sync: boolean;
}

const Index = ({ integrations, should_show_sync }: Props) => {
  const accounts = integrations.google.accounts;
  const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content;
  const { flash } = usePage<InertiaSharedProps>().props;
  const TRACK = useAnalytics();

  // TODO: confirm desired max; default to 3 for now
  const MAX_ENABLED_CALENDARS = 3;

  useEffect(() => {
    if (flash.notice === "Google Calendar connected.") {
      TRACK.CALENDAR_CONNECTED("google");
    }
  }, [flash.notice, TRACK]);

  return (
    <Box maxW="3xl" mx="auto" py={10}>
      <Head title="Integrations - Muro" />
      <Flex alignItems="center" justifyContent="space-between" mb={6}>
        <Flex alignItems="center" gap={3}>
          <Heading as="h1" size="xl">
            Integration
          </Heading>
          {should_show_sync && (
            <form action={sync_integrations_path()} method="post">
              <input type="hidden" name="authenticity_token" value={csrfToken} />
              <Button type="submit" size="sm" colorPalette="gray" variant="outline" cursor="pointer">
                Sync
              </Button>
            </form>
          )}
        </Flex>
        <form action={integrations_calendars_google_index_path()} method="post">
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <Button
            type="submit"
            aria-label="Connect account"
            disabled={accounts.length >= 3}
            size="sm"
            fontSize="sm"
            bg="primary-base"
            color="on-primary-base"
            _hover={{ bg: "primary-hover" }}
            cursor="pointer"
          >
            + Add integration
          </Button>
        </form>
      </Flex>

      <VStack gap={4} alignItems="stretch">
        {accounts.length === 0 && (
          <Text fontSize="sm" color="gray.600">
            No accounts connected yet.
          </Text>
        )}

        {accounts.map((account) => (
          <AccountCard key={account.id} providerAccount={account} max={MAX_ENABLED_CALENDARS} />
        ))}
      </VStack>
    </Box>
  );
};

Index.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>;

export default Index;
